import BaseApiController from 'controller/baseresourcecontroller';

export default class BaseSystemTableController extends BaseApiController {
  constructor(type) {
    super(type);
  }

  async GetItem (autoid) {
    return super.Post('GetItem', { autoid: autoid });
  }

  async GetNew () {
    return super.Post('GetNew');
  }

  async Save (viewmodel) {
    return super.Post('save', viewmodel);
  }

  async Delete (autoid) {
    return super.Post('delete', { autoid: autoid });
  }

  async GetForm () {
    return super.Get('GetForm');
  }

}
